import ISpecies from "../Models/ISpecies";

const species: { [id: string]: ISpecies } = {
    "bourdon": {
        "name": "Bourdon",
        "gender": "male",
        "image": "/image/species/bourdon.png",
        "skills": [
            {
                "empathy": 2,
                "stamina": 2,
                "medicine": 2,
                "strength": 1,
                "perception": 1
            },
            {
                "empathy": 2,
                "stamina": 2,
                "medicine": 2,
                "strength": 1,
                "perception": 1
            },
            {
                "empathy": 2,
                "stamina": 2,
                "medicine": 2,
                "strength": 1,
                "perception": 1,
                "survival": 1
            },
            {
                "empathy": 2,
                "stamina": 2,
                "medicine": 2,
                "strength": 1,
                "perception": 1,
                "survival": 1
            }
        ],
        "hp": [
            10,
            10,
            13,
            13
        ]
    },
    "guepe": {
        "name": "Guêpe",
        "gender": "female",
        "image": "/image/species/guepe.png",
        "skills": [
            {
                "agility": 2,
                "tracking": 2,
                "survival": 2,
                "strength": 1,
                "medicine": 1
            },
            {
                "agility": 2,
                "tracking": 2,
                "survival": 2,
                "strength": 1,
                "medicine": 1
            },
            {
                "agility": 2,
                "tracking": 2,
                "survival": 2,
                "strength": 1,
                "medicine": 1,
                "discretion": 1
            },
            {
                "agility": 2,
                "tracking": 2,
                "survival": 2,
                "strength": 1,
                "medicine": 1,
                "discretion": 1
            }
        ],
        "hp": [
            10,
            10,
            15,
            15
        ]
    },
    "coccinelle": {
        "name": "Coccinelle",
        "gender": "female",
        "image": "/image/species/coccinelle.png",
        "skills": [
            {
                "agility": 2,
                "discretion": 2,
                "tracking": 2,
                "intimidation": 1,
                "searching": 1
            },
            {
                "agility": 2,
                "discretion": 2,
                "tracking": 2,
                "intimidation": 1,
                "searching": 1
            },
            {
                "agility": 2,
                "discretion": 2,
                "tracking": 2,
                "intimidation": 1,
                "searching": 1,
                "strength": 1
            },
            {
                "agility": 2,
                "discretion": 2,
                "tracking": 2,
                "intimidation": 1,
                "searching": 1,
                "strength": 1
            }
        ],
        "hp": [
            9,
            9,
            11,
            11
        ]
    },
    "mouche": {
        "name": "Mouche",
        "gender": "female",
        "image": "/image/species/mouche.png",
        "skills": [
            {
                "searching": 2,
                "intuition": 2,
                "perception": 2,
                "empathy": 1,
                "medicine": 1
            },
            {
                "searching": 2,
                "intuition": 2,
                "perception": 2,
                "empathy": 1,
                "medicine": 1
            },
            {
                "searching": 2,
                "intuition": 2,
                "perception": 2,
                "empathy": 1,
                "medicine": 1,
                "agility": 1
            },
            {
                "searching": 2,
                "intuition": 2,
                "perception": 2,
                "empathy": 1,
                "medicine": 1,
                "agility": 1
            }
        ],
        "hp": [
            7,
            7,
            9,
            9
        ]
    },
    "paon-du-jour": {
        "name": "Paon-du-jour",
        "gender": "male",
        "image": "/image/species/paon-du-jour.png",
        "skills": [
            {
                "empathy": 2,
                "intuition": 2,
                "persuasion": 2,
                "agility": 1,
                "perception": 1
            },
            {
                "empathy": 2,
                "intuition": 2,
                "persuasion": 2,
                "agility": 1,
                "perception": 1
            },
            {
                "empathy": 2,
                "intuition": 2,
                "persuasion": 2,
                "agility": 1,
                "perception": 1,
                "intimidation": 1
            },
            {
                "empathy": 2,
                "intuition": 2,
                "persuasion": 2,
                "agility": 1,
                "perception": 1,
                "intimidation": 1
            }
        ],
        "hp": [
            9,
            9,
            12,
            12
        ]
    },
    "scarabee": {
        "name": "Scarabée",
        "gender": "male",
        "image": "/image/species/scarabee.png",
        "skills": [
            {
                "stamina": 2,
                "strength": 2,
                "intimidation": 2,
                "persuasion": 1,
                "survival": 1
            },
            {
                "stamina": 2,
                "strength": 2,
                "intimidation": 2,
                "persuasion": 1,
                "survival": 1
            },
            {
                "stamina": 2,
                "strength": 2,
                "intimidation": 2,
                "persuasion": 1,
                "survival": 1,
                "intuition": 1
            },
            {
                "stamina": 2,
                "strength": 2,
                "intimidation": 2,
                "persuasion": 1,
                "survival": 1,
                "intuition": 1
            }
        ],
        "hp": [
            10,
            10,
            15,
            15
        ]
    },
    "moro-sphynx": {
        "name": "Moro-sphynx",
        "gender": "male",
        "image": "/image/species/moro-sphynx.png",
        "skills": [
            {
                "agility": 2,
                "strength": 2,
                "survival": 2,
                "stamina": 1,
                "intimidation": 1
            },
            {
                "agility": 2,
                "strength": 2,
                "survival": 2,
                "stamina": 1,
                "intimidation": 1
            },
            {
                "agility": 2,
                "strength": 2,
                "survival": 2,
                "stamina": 1,
                "intimidation": 1,
                "tracking": 1
            },
            {
                "agility": 2,
                "strength": 2,
                "survival": 2,
                "stamina": 1,
                "intimidation": 1,
                "tracking": 1
            }
        ],
        "hp": [
            10,
            10,
            15,
            15
        ]
    }
}

export default species;